import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=6bcd7f2c&"
import script from "./VideoPlayer.ts?vue&type=script&lang=ts&"
export * from "./VideoPlayer.ts?vue&type=script&lang=ts&"
import style0 from "./VideoPlayer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports